"use strict";

module.exports = {
  'name': 'factorial',
  'category': 'Probability',
  'syntax': ['n!', 'factorial(n)'],
  'description': 'Compute the factorial of a value',
  'examples': ['5!', '5 * 4 * 3 * 2 * 1', '3!'],
  'seealso': ['combinations', 'permutations', 'gamma']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/probability/factorial.js
// module id = 912
// module chunks = 0